import React from 'react';
import DynamicContentRenderer from '../DynamicContentRenderer';
import { VersionLogRootRecord } from '../records/VersionLogRootRecord';

const RootRenderer: React.FC<VersionLogRootRecord> = ({ children }) => {
  if (!Array.isArray(children)) {
    return null;
  }
  return <DynamicContentRenderer schema={children} />;
};

export default RootRenderer;
